import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {BLOCK_GET_BLOCKS_AUTOCOMPLETE, BLOCK_GET_BLOCKS_MASTER, BLOCK_MODULE_NAMESPACE} from '../../../../store/block'
import {IUserDetails} from '../../../../models/user'
import {BlockParameter, IBlockParameter} from '../../../../models/block'
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store'
import {GenericDefaultSelectOption, IGenericDefaultSelectOption} from '../../../../models/generic'
import {SearchEntities, SearchSortTypes, StateTypes} from '../../../../common/enums'
import {IReceptionParameter, ReceptionParameter} from '../../../../models/reception'
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS} from '../../../../store/search'
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_SET_LOADER_STATE, RECEPTION_LOADERS } from '../../../../store/reception/reception-types.store'

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const UPDATE_PARAM: string = 'update:param'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)

@Component({
  components: {
    'reception-filters-loader': async () => import('../../loaders/reception-filters-loader/ReceptionFiltersLoader.vue')
  }
})
class MHReceptionSidebar extends Vue {
  dtTab: string
  dtTabs: string[]
  dtTemporaryDeclarant: any[] | null;
  dtTemporaryBlock: any[] | null;

  /**
   *
   */
  @Prop({ default: () => new ReceptionParameter, type: [Object] })
  param: IReceptionParameter;

  constructor () {
    super()
    this.dtTab = null
    this.dtTabs = [
      'basicSearch'
    ]
    this.dtTemporaryDeclarant = []
    this.dtTemporaryBlock = []
  }

  @UserStore.Getter userInfo: IUserDetails;
  @BlockStore.Getter blocks: any[];
  @SearchStore.Getter declarants: any[]

  @BlockStore.Action(BLOCK_GET_BLOCKS_MASTER)
  storeGetBlocks: (payload: { userInfo: IUserDetails, param?: any }) => Promise<any>
  //storeGetBlocks: (payload:any) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS)
  storeGetDeclarants: (keys: SearchEntities[]) => Promise<any>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @ReceptionStore.Mutation(RECEPTION_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void


  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/ticket').default,
    }
  }
  get coDeclarants () {
    // return this.declarants;
    /*
    return (this.declarants || []).map(declarant => {
      return { value: declarant.id, text: `${declarant.firstname} ${declarant.lastname}` }
    });
    */
    return this.dtTemporaryDeclarant.map(x => ({ value: x.id, text: x.fullname }))
  }
  get coBlocks () {
    /* return this.blocks.map(b => {
      return { value: b.id, text: b.name }
    }) */
    return this.dtTemporaryBlock.map(x => ({ value: x.id, text: x.name }))
  }
  get coSortTypes (): IGenericDefaultSelectOption<number>[] {
    return [SearchSortTypes.MoreRecent,
      SearchSortTypes.Older].map(val => new GenericDefaultSelectOption<number>(this.$t(this.lblSetting.lblSort[`lblSortType${val}`]).toString(), val))
  }
  get coStates (): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.InProgress,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type))
  }

  get blockSearchParameter () {
    return {
      userInfo: this.userInfo,
      param: new BlockParameter
    }
  }
  get sortValues (): number[] {
    return this.param.orderValues
  }
  set sortValues (val: number[]) {
    this.$emit(UPDATE_PARAM, { ...this.param, orderValues: val, $skip: 0 })
  }

  get creator (): number[] {
    return this.param.creator
  }
  set creator (val: number[]) {
    this.$emit(UPDATE_PARAM, { ...this.param, creator: val, $skip: 0 })
  }
  get fKTicketBlock (): number[] {
    return this.param.block
  }
  set fKTicketBlock (val: number[]) {
    this.$emit(UPDATE_PARAM, { ...this.param, block: val, $skip: 0 })
  }
  get fKTicketState (): string[] | number[] {
    return this.param.state
  }
  set fKTicketState (val: string[] | number[]) {
    this.$emit(UPDATE_PARAM, { ... this.param, state: val, $skip: 0 })
  }

  getEntities() {
    let entities = [SearchEntities.Manager, SearchEntities.Salesperson]
    if(this.$route.path === '/vehicle-check')
    {
      entities.push(SearchEntities.MaintenanceReferent, SearchEntities.VehicleReferent)
    } else {
      entities = [SearchEntities.Manager, SearchEntities.Salesperson]
    }
    return entities
  }

  mounted () {
    /* this.storeGetBlocks(this.blockSearchParameter).then(res=>{
      this.dtTemporaryBlock = res
    }).catch(error => console.log(error)) */
    // this.storeGetDeclarants([SearchEntities.Manager, SearchEntities.Salesperson]).then()

    this.storeGetEntitySearch({entity: this.getEntities(), query: ''})
      .then(res => {
        this.dtTemporaryDeclarant = res
      })
  }
  handleRemoteFetch (key: string, cb: Function, loading: Function) {
    this.storeGetBlocksAutocomplete({ key })
      .then(res => {
        cb((res || []).map(x => ({ value: x.id, text: x.name })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  handleGetDeclarants (key: string, cb: Function, loading: Function) {
    return this.storeGetEntitySearch({
      entity: this.getEntities(), query: key, limit: 50
    })
      .then(res => {
        cb((res || []).map(x => ({ value: x.id, text: x.fullname })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }
  setFilterLoaderState(value: boolean){
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.FILTERS, value })
  }
}

export default MHReceptionSidebar



// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-conditions/index.ts